module.exports = __webpack_public_path__ + "public/images/icon-whatsapp.f839fe08308d1037eb8c262348a2240d.svg";